import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
var DEFAULT_SALT = 'AL0vBGr4cmOglQgkSVQL';
// https://developer.mozilla.org/en-US/docs/Web/API/SubtleCrypto/digest#examples
export function hashEmail(_x) {
  return _hashEmail.apply(this, arguments);
}
function _hashEmail() {
  _hashEmail = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(email) {
    var msgBuffer, hashBuffer, hashArray, hashHex;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          // encode as UTF-8
          msgBuffer = new TextEncoder().encode(email + DEFAULT_SALT); // hash the message
          _context.next = 3;
          return crypto.subtle.digest('SHA-256', msgBuffer);
        case 3:
          hashBuffer = _context.sent;
          // convert ArrayBuffer to Array
          hashArray = Array.from(new Uint8Array(hashBuffer)); // convert bytes to hex string
          hashHex = hashArray.map(function (b) {
            return b.toString(16).padStart(2, '0');
          }).join('');
          return _context.abrupt("return", hashHex.substring(0, 8));
        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _hashEmail.apply(this, arguments);
}